
import PropTypes from 'prop-types';
import CustomText from '../atoms/custom-text.atom';
import { FaTimes } from 'react-icons/fa';
import PDFRenderer from '../molecules/pdf-renderer.molecule';
const PDFModal = ({
    isOpen,
    onClose,
    title,
    pdfUrl,
    width = '100%',
    height = '80vh',
}) => {
    if (!isOpen || !pdfUrl) return null;

    return (
        <div style={styles.overlay} onClick={onClose}>
            <div style={styles.modal} onClick={e => e.stopPropagation()}>
                <div style={styles.header}>
                    <CustomText variant="headline2xl">{title}</CustomText>
                    <FaTimes 
                        onClick={onClose} 
                        style={styles.closeIcon}
                    />
                </div>
                <div style={styles.content}>
                    <PDFRenderer
                        file={pdfUrl}
                        width={width}
                        height={height}
                        onLoadError={(error) => console.error('Error loading PDF:', error)}
                    />
                </div>
            </div>
        </div>
    );
};

PDFModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    pdfUrl: PropTypes.string.isRequired,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
};

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
    },
    modal: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        width: '90%',
        maxWidth: '1200px',
        maxHeight: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    header: {
        padding: '16px',
        borderBottom: '1px solid #626262',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    closeIcon: {
        cursor: 'pointer',
        color: '#626262',
        fontSize: '24px',
        transition: 'color 0.2s ease',
        '&:hover': {
            color: '#000',
        },
    },
    content: {
        padding: '16px',
        overflow: 'auto',
        flex: 1,
    },
};

export default PDFModal; 